import { FaCog, FaSearch } from "react-icons/fa";
import styled from "styled-components";
import { useTheme } from "../../context/useThemeContext";
import useMainStore from "../../stores/mainStore";

function Footer() {
    const { theme } = useTheme();

    return (
        <div
            className="h-[34px] flex px-3"
            style={{
                backgroundColor: theme.headerColor,
            }}
        >
            <div className="search-bar flex flex-1 items-center gap-[2px]">
                <FaSearch
                    color={theme.fontColor[100]}
                    size={14}
                    className="mb-[1px]"
                />
                <InputStyled
                    placeholder="Filter"
                    className="fit-width bg-transparent ml-[6px] text-xs outline-none"
                    style={{
                        color: theme.fontColor[50],
                        minWidth: "0px",
                    }}
                    $fontcolor={theme.fontColor[100]}
                    onChange={(e) => {
                        useMainStore
                            .getState()
                            .set.filterString(() => e.target.value);
                    }}
                />
            </div>
            {/* <div className="settings flex items-center">
                <FaCog color={theme.fontColor[100]} size={16} />
            </div> */}
        </div>
    );
}

export default Footer;

const InputStyled = styled.input<{ $fontcolor: string }>`
    /* color: red; */

    &::placeholder {
        color: ${(props) => props.$fontcolor};
        opacity: 0.75;
    }
`;
